<template>
	<div :class="{loader: isLoading}" v-if="!isLoading">
		<div
			class="row history-item py-2"
			v-for="(item, index) in historyItems"
			:key="'history'+index"
			:class="{returned: item.activity == 'rejected', confirmed: item.activity == 'confirmed', completed: item.activity == 'completed'}"
		>
			<div class="col-md-12 p-0">
				<strong>
					<i>{{item.userName}}</i>
				</strong>
				{{$t(`coordinations.activities.${item.activity}`)}} - {{$moment(item.createdOn).format('DD MMM YYYY HH:mm')}}
			</div>
			<div v-if="item.text" class="col-md-12 p-0">
				<strong>{{$t('coordinations.comment')}}:</strong>
				{{item.text}}
			</div>
		</div>
	</div>
</template>

<script>
import coordinationsService from '@/services/coordinations.service';
import { TaskHistoryItem } from '@/models/task.models';

export default {
	props: {
		taskId: { type: Number, required: true }
	},
	data() {
		return {
			historyItems: [],
			isLoading: false
		};
	},
	methods: {
		async fetchHistory() {
			try {
				var result = await coordinationsService.getHistory(this.taskId);
				result.data.forEach(element => {
					this.historyItems.push(new TaskHistoryItem(element));
				});
			} catch (err) {
				this.$vs.notify({
					color: 'danger',
					title: this.$t('notifications.error'),
					text: this.$helpers.errorText(err)
				});
			}
		}
	},
	mounted() {
		this.fetchHistory();
	}
};
</script>

<style lang="scss" scoped>
.history-item {
	border-bottom: 1px solid lightgrey;
	padding-left: 3px;

	&.returned {
		border-left: 3px solid rgba(255, 0, 0, 0.5);
	}

	&.confirmed {
		border-left: 3px solid rgba(0, 255, 0, 0.5);
	}

	&.completed {
		border-left: 3px solid rgba(0, 0, 255, 0.5);
	}
}
</style>
